import React from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import classNames from 'classnames';
import * as AppState from '../../../../AppState'; 
import FilterDropdown from '../../../Shared/FilterDropdown/FilterDropdown';
import BedsAndBaths from './BedsAndBaths';

import './BedsAndBathsButton.scss';

const BedsAndBathsButton = () => {
	const gsBedsFilterApplied = useRecoilValue(AppState.gsBedsFilterApplied);
	const gsBathsFilterApplied = useRecoilValue(AppState.gsBathsFilterApplied);
	const [gsFilters, setGsFilters] = useRecoilState(AppState.gsFilters);
	const [buttonLabel, setButtonLabel] = React.useState('Beds & Baths');

	// Apply filter values to label

	React.useEffect(() => {
		// If both filters, show both values
		if (gsFilters.bedroomsMin !== 0 && gsFilters.bathroomsMin !== 0) {
			setButtonLabel(`${gsFilters.bedroomsMin}+ Bd, ${gsFilters.bathroomsMin}+ Ba`);
		} else if (gsFilters.bedroomsMin !== 0 && gsFilters.bathroomsMin === 0) {
			// If beds but not baths, show beds
			setButtonLabel(`${gsFilters.bedroomsMin}+ Bed`);
		} else if (gsFilters.bedroomsMin === 0 && gsFilters.bathroomsMin !== 0) {
			// If baths but not beds, show baths
			setButtonLabel(`${gsFilters.bathroomsMin}+ Bath`);
		} else setButtonLabel('Beds & Baths');
	}, [gsFilters.bedroomsMin, gsFilters.bathroomsMin]);

	return (
		<FilterDropdown
			id="homesearchBedsBathsDropdown"
			label={buttonLabel}
			active={gsBedsFilterApplied || gsBathsFilterApplied}
			className={classNames(((gsBedsFilterApplied || gsBathsFilterApplied) ? 'cc-btn--secondary homesearch-filters__cc-btn--active' : 'cc-btn--gray'), 'cc-btn cc-btn--outline cc-btn--reset-text justify-content-center cc-btn--navbar homesearch-filters__cc-btn--beds-baths')}
			options={ <BedsAndBaths /> }
			onResetClick={() => {

				setGsFilters(currVal => ({...currVal, bedroomsMin: 0, bathroomsMin: 0}));
			}}
		/>
	);
};

export default BedsAndBathsButton;
